import { render, staticRenderFns } from "./layout-product-places.vue?vue&type=template&id=565d1811"
import script from "./layout-product-places.vue?vue&type=script&lang=js"
export * from "./layout-product-places.vue?vue&type=script&lang=js"
import style0 from "./layout-product-places.vue?vue&type=style&index=0&id=565d1811&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports